import { pictureStorageBaseUrl } from '../Picture/contentfulImageProxy.js';
import type { JSX, ReactNode } from 'react';

import './PublicSubscriptionImageCards.scss';

export type PublicSubscriptionImageCardsProps = {
  items: {
    anchor?: string;
    content: JSX.Element;
    image: string | ReactNode;
    imageAlt?: string;
    title: ReactNode;
  }[];
  alignLeft?: boolean;
  fourCardsPerRow?: boolean;
};

// This one done only because DS's card container did not have support for image alt's, can be replaced with that when support is there..
export const PublicSubscriptionImageCards = ({
  items,
  alignLeft = false,
  fourCardsPerRow = false,
}: PublicSubscriptionImageCardsProps): JSX.Element => (
  <div
    className={`of-public-subscription-image-cards ${
      alignLeft ? 'of-public-subscription-image-cards__align-left' : ''
    } ${fourCardsPerRow ? 'of-public-subscription-image-cards__four-cards-per-row' : ''} `}
  >
    {items.map((item, index) => {
      const { content, image, imageAlt, title } = item;
      const isImageString = typeof image === 'string';
      return (
        <div id={item.anchor} key={isImageString ? image : `item-${index}`}>
          {isImageString ? (
            <img alt={imageAlt} src={`${pictureStorageBaseUrl}${image}`} />
          ) : (
            <div className="of-public-subscription-image-cards__icon">{image}</div>
          )}
          <h3>{title}</h3>
          <div className="of-public-subscription-image-cards__content">{content}</div>
        </div>
      );
    })}
  </div>
);
